import { OverlayContainer } from '@angular/cdk/overlay';
import { AfterContentInit, Component, ElementRef, Inject, Renderer2, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { detect } from 'detect-browser';
import * as moment from 'moment';


import { DOCUMENT } from '@angular/common';
import { Observable, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { NavMenuComponent } from './components/nav-menu/nav-menu.component';
import { ENavigationErrorType } from './model/enum/navigation-error-type';
import { ENavigationRoute } from './model/enum/navigation-route';
import { ThemeLoaderService } from './services/theme.service';
import { CoreData } from './tools/core-data/core-data';
import { LoadingTask } from './tools/ui/loading-task';

const browser = detect();

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements AfterContentInit {
    @ViewChild(NavMenuComponent)
    menu!: NavMenuComponent;
    @ViewChild('tata', { read: ElementRef })
    mainContainer!: ElementRef;
    title = 'AngularClientTemplate';
    PageHeight!: string;
    Overflow!: string;
    Opacity = 0;
    isDarkTheme: Observable<boolean> = this.themeLoaderService.isDarkTheme;
    isDark: boolean = false;
    subscription: Subscription | undefined;
    get IsLoggedIn() {
        return this.coreData.IsLoggedIn;
    }

    constructor(
        private renderer: Renderer2,
        private overlayContainer: OverlayContainer,
        private themeLoaderService: ThemeLoaderService,
        private loadingTask: LoadingTask,
        private route: ActivatedRoute,
        private router: Router,
        private coreData: CoreData,
        
        @Inject(DOCUMENT) private document: Document) {
        moment.locale('fr');
        if (!coreData.isMEL) {
            this.overlayContainer.getContainerElement().classList.add('eab-theme');
        }
        // this.renderer.listen('window', 'click', (e: Event) => {
        //     console.log(e);
        // });
    }

    ngAfterContentInit(): void {
        if (this.coreData.IsMobile && this.coreData.IsLoggedIn) {
            this.PageHeight = `calc(100% - 190px)`;
        } else if (this.coreData.IsMobile && !this.coreData.IsLoggedIn) {
            this.PageHeight = `calc(100% - 80px)`;
        } else {
            this.PageHeight = `calc(100% - 210px)`;
        }
        this.Overflow = 'auto';

        if (browser && browser.name === 'ie') {
            this.router.navigate([ENavigationRoute.Error, { type: ENavigationErrorType.IE }]);
        }

        this.isDarkTheme = this.themeLoaderService.isDarkTheme;

        this.loadingTask.LoadingEmitter.subscribe(x => {
            if (x) {
                this.Opacity = 100;
            } else {
                this.Opacity = 0;
            }
        });

        // if (this.coreData.isMEL) {
        //     this.document?.getElementById('appFavicon')?.setAttribute('href', 'assets/favicon-mel.ico');
        //     this.document.getElementsByTagName('')
        // }
        // const source = interval(5000);
        // this.subscription = source.subscribe(val =>  {
        //     this.isDark = !this.isDark;
        //     this.themeLoaderService.setDarkTheme(this.isDark);
        //     console.log(`CHANGE THEME to ${this.isDark}`);
        // });

        setTimeout(() => {
            this.themeLoaderService.setDarkTheme(environment.isMel);
        }, 0);

    }

    updateHeight(event: any) {
        this.Overflow = 'hidden';
        setTimeout(() => {
            this.PageHeight = `calc(100% - ${event})`;
            this.Overflow = 'auto';
        }, 0);
    }
}

